"use client";

import { Button, type ButtonProps } from "./button";

type CloseButtonProps = Omit<ButtonProps, "onClick">


export default function CloseButton(props: CloseButtonProps) {
  return (
    <Button
      {...props}
      onClick={() => {
        window.close();
      }}
    />
  )
}